namespace RioERP.Products {
    export interface SubjectsRow {
        Id?: number;
        CategoryId?: number;
        Name?: string;
        Description?: string;
        CategoryName?: string;
        CategoryIsWebsiteCategory?: boolean;
        CategoryWebsiteCategoryId?: string;
        CategoryDescription?: string;
        CategoryParentId?: number;
        CategoryIsActive?: boolean;
        CategoryInsertUserId?: number;
        CategoryInsertDate?: string;
        CategoryUpdateUserId?: number;
        CategoryUpdateDate?: string;
    }

    export namespace SubjectsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Products.Subjects';
        export const lookupKey = 'Products.Subjects';

        export function getLookup(): Q.Lookup<SubjectsRow> {
            return Q.getLookup<SubjectsRow>('Products.Subjects');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            CategoryId = "CategoryId",
            Name = "Name",
            Description = "Description",
            CategoryName = "CategoryName",
            CategoryIsWebsiteCategory = "CategoryIsWebsiteCategory",
            CategoryWebsiteCategoryId = "CategoryWebsiteCategoryId",
            CategoryDescription = "CategoryDescription",
            CategoryParentId = "CategoryParentId",
            CategoryIsActive = "CategoryIsActive",
            CategoryInsertUserId = "CategoryInsertUserId",
            CategoryInsertDate = "CategoryInsertDate",
            CategoryUpdateUserId = "CategoryUpdateUserId",
            CategoryUpdateDate = "CategoryUpdateDate"
        }
    }
}
